import { useEffect } from 'react';

const useMutationObserver = (target, options, onMutate) => useEffect(() => {
  if (!target) {
    return undefined;
  }
  const observer = new MutationObserver(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onMutate === null || onMutate === void 0 || onMutate(...args);
  });
  observer.observe(target, options);
  return () => observer.disconnect();
}, [target, options, onMutate]);

export { useMutationObserver as default };
